<template>
  <div class="container request-list">
    <md-list class="list_no-background">
      <template v-for="request in list">
        <md-list-item :key="request.saleIndex" @click="$emit(commonEvents.saleSelectEvent, request)">
          <div class="request-list__name text_large">
            <div>{{ cookUpHeading(request) }}</div>
            <div>{{ request.name }}</div>
            <div :class="`request-list__request
                           request-list__request--${request.state}`">
              {{ request.state || i18n.sale_in_process_of_creation() }}
            </div>
          </div>
          <div class="request-list__control text_medium">
            {{ i18n.lbl_continue() }}
            <md-icon md-src="/static/img/arrow_continue_icon.svg"></md-icon>
          </div>
        </md-list-item>
      </template>
    </md-list>
  </div>
</template>

<script>
  import { commonEvents } from '@js/events/common_events'
  import { i18n } from '@js/i18n'

  export default {
    name: 'RequestList',
    props: { list: { type: Array, required: true } },
    data: _ => ({
      i18n,
      commonEvents
    }),
    methods: {
      cookUpHeading (request) {
        return request.name
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .request-list {

    &__name {
      padding-right: 8px;
      color: $col-text;
      font-weight: 700;
      overflow: hidden;
      transition: .3s;

      & *{
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__control {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      align-items: center;
      color: $col-md-primary;
      transition: .3s;

      & .md-icon {
        display: flex;
        margin-left: 8px;

        & /deep/ svg {
          width: 13px;
          height: 8px;
        }
      }
    }

    & /deep/ .md-list-item {

      &:hover {
        & .request-list {
          &__name {
            color: $col-text-secondary;
          }

          &__control {
            opacity: .4;
          }
        }
      }

      &:not(:first-child) {
        border-top: 1px solid $col-border;
      }
    }

    & /deep/ .md-list-item-content {
      padding: 30px 40px;

      @include respond-to(small) {
        padding: 18px 22px;
      }
    }

    &__request {
      &--pending  { color: $col-md-accent !important; }
      &--approved { color: $col-md-primary !important; }
      &--rejected { color: $col-error  !important; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/saleCreation/SaleCreation.RequestList.vue